import React, { useState } from 'react';
import { Icon } from '../../atoms';
import classes from './AccordionTile.module.scss';

type AccordionTileProps = {
  title?: string;
  content?: string;
};

export function AccordionTile({ title, content }: AccordionTileProps) {
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      className={classes.AccordionItem}
      tabIndex={0}
      role='button'
      onKeyDown={(e) => e.key === 'Enter' && setIsActive(!isActive)}
    >
      <div className={classes.AccordionTitle} onClick={() => setIsActive(!isActive)} aria-expanded={isActive}>
        <div>{title}</div>
        <div>
          {isActive ? (
            <div className={classes.ItemOpenChevron}>
              <Icon icon='chevron' size={16} color={'black'} />
            </div>
          ) : (
            <div className={classes.ItemClosedChevron}>
              <Icon icon='chevron' size={16} color={'black'} />
            </div>
          )}
        </div>
      </div>
      {isActive && <div className={classes.AccordionContent}>{content}</div>}
    </div>
  );
}
